import {ErrorHandler, Injectable} from "@angular/core";

@Injectable()
export class SimErrorHandler extends ErrorHandler {
	handleError(error: any): void {
		if (error) {
			const chunkFailedMessage_WebPack = /Loading chunk \d+ failed/;
			const chunkFailedMessage_Vite = /Failed to fetch dynamically imported module/;
			const expressionChangedAfterItHasBeenCheckedMessage = /ExpressionChangedAfterItHasBeenCheckedError/;

			//https://medium.com/@kamrankhatti/angular-lazy-routes-loading-chunk-failed-42b16c22a377
			if (chunkFailedMessage_WebPack.test(error.message)) {
				window.location.reload();
			}

			if (chunkFailedMessage_Vite.test(error.message)) {
				window.location.reload();
			}

			if (expressionChangedAfterItHasBeenCheckedMessage.test(error.message)) {
				return;
			}
		}

		super.handleError(error);
	}
}
